import axios from 'axios'
import { ElMessage } from 'element-plus'
import router from '../router'

const service = axios.create({
  baseURL: '/api/v1',
  // 30s：图片上传等慢接口单独用更大超时；普通请求给足网络抖动余量
  timeout: 30000
})

// 请求拦截器：携带 token
service.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('adminToken')
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  (error) => Promise.reject(error)
)

// 响应拦截器：统一处理 {code,msg,data}
service.interceptors.response.use(
  (response) => {
    const res = response.data
    // 非契约结构（如文件下载）直接返回
    if (res === undefined || res === null || typeof res !== 'object' || !('code' in res)) {
      return res
    }
    if (res.code === 0) {
      return res
    }
    ElMessage.error(res.msg || '请求失败')
    if (res.code === 401) {
      localStorage.removeItem('adminToken')
      router.push('/login')
    }
    return Promise.reject(new Error(res.msg || 'Error'))
  },
  (error) => {
    const status = error.response && error.response.status
    if (status === 401) {
      localStorage.removeItem('adminToken')
      router.push('/login')
    }
    // 区分超时 / 断网 / 其它错误，给出中文提示，避免直接暴露 axios 的英文技术消息
    const isTimeout = error.code === 'ECONNABORTED' || /timeout/i.test(error.message || '')
    if (isTimeout) {
      ElMessage.error('请求超时，请检查网络后重试')
    } else if (!error.response) {
      ElMessage.error('网络异常，请检查网络连接')
    } else {
      ElMessage.error((error.response.data && error.response.data.msg) || error.message || '请求失败')
    }
    return Promise.reject(error)
  }
)

export default service
